import React, { useState } from 'react';
import { FaReact, FaNetworkWired, FaHtml5, FaDocker, FaLinux, FaDatabase, FaAws, FaRaspberryPi, FaCertificate, FaExternalLinkAlt, FaCode, FaCloud, FaServer } from 'react-icons/fa';
import { SiKubernetes, SiPython, SiC, SiCisco, SiRedhat, SiGrafana, SiTerraform } from 'react-icons/si';

const allSkills = [
  // Software Track
  { name: 'React Development', track: 'software', category: 'Software Development', icon: <FaReact color="#61dafb" size={38} />, proficiency: 'Advanced' },
  { name: 'Python Programming', track: 'software', category: 'Software & Data', icon: <SiPython color="#FFD43B" size={38} />, proficiency: 'Advanced' },
  { name: 'C Language', track: 'software', category: 'Software Development', icon: <SiC color="#A8B9CC" size={38} />, proficiency: 'Intermediate' },
  { name: 'HTML5 / Modern Web', track: 'software', category: 'Software Development', icon: <FaHtml5 color="#E44D26" size={38} />, proficiency: 'Advanced' },

  // Cloud Track
  { name: 'AWS Cloud Platform', track: 'cloud', category: 'Cloud Infrastructure', icon: <FaAws color="#FF9900" size={38} />, proficiency: 'Advanced' },
  { name: 'Terraform (IaC)', track: 'cloud', category: 'Cloud Infrastructure', icon: <SiTerraform color="#623CE4" size={38} />, proficiency: 'Advanced' },
  { name: 'Docker Containers', track: 'cloud', category: 'Cloud & DevOps', icon: <FaDocker color="#2496ED" size={38} />, proficiency: 'Advanced' },
  { name: 'Kubernetes', track: 'cloud', category: 'Cloud & DevOps', icon: <SiKubernetes color="#326ce5" size={38} />, proficiency: 'Intermediate' },
  { name: 'Red Hat OpenShift', track: 'cloud', category: 'Cloud & Enterprise OS', icon: <img src="/openshiftlogo.png" alt="OpenShift" style={{ width: 44, height: 36 }} />, proficiency: 'Intermediate' },
  { name: 'VMware Virtualization', track: 'cloud', category: 'Virtualization & Cloud', icon: <img src="/vmwarelogo.jpeg" alt="VMware" style={{ width: 38, height: 38, borderRadius: '4px' }} />, proficiency: 'Intermediate' },

  // Data Track
  { name: 'SQL & Relational DBs', track: 'data', category: 'Data Analysis', icon: <FaDatabase color="#5e5e5e" size={38} />, proficiency: 'Advanced' },
  { name: 'Grafana Monitoring', track: 'data', category: 'Data & Dashboards', icon: <SiGrafana color="#F46800" size={38} />, proficiency: 'Advanced' },

  // Networking Track
  { name: 'Cisco Networking (CCNA)', track: 'network', category: 'Network Engineering', icon: <FaNetworkWired color="#2575c2" size={38} />, proficiency: 'Advanced' },
  { name: 'CyberOps & Security', track: 'network', category: 'Network Security', icon: <SiCisco color="#1BA0D7" size={38} />, proficiency: 'Advanced' },

  // IT & Systems Track
  { name: 'Linux System Admin', track: 'it', category: 'IT & Systems Admin', icon: <FaLinux color="#FCC624" size={38} />, proficiency: 'Advanced' },
  { name: 'Smart IoT (Raspberry Pi)', track: 'it', category: 'Smart IoT Systems', icon: <FaRaspberryPi color="#C72E27" size={38} />, proficiency: 'Advanced' },
];

const certifications = [
  {
    title: "Red Hat Academy - Program Learner",
    issuer: "Red Hat",
    date: "Nov 2024 - Nov 2025",
    icon: <SiRedhat color="#EE0000" size={36} />,
    track: "Cloud & Linux",
    verifyTag: "Verified Credentials"
  },
  {
    title: "AWS Academy Graduate - AWS Academy Cloud Architecting",
    issuer: "Amazon Web Services (AWS)",
    date: "Oct 2024",
    icon: <FaAws color="#FF9900" size={36} />,
    track: "Cloud Architecture",
    verifyTag: "AWS Badge Verified"
  },
  {
    title: "Ethical Hacker",
    issuer: "Cisco",
    date: "Oct 2024",
    icon: <SiCisco color="#1BA0D7" size={36} />,
    track: "Cybersecurity",
    verifyTag: "Cisco Verified"
  },
  {
    title: "AWS Academy Graduate - AWS Academy Introduction to Cloud Semester 2",
    issuer: "Amazon Web Services (AWS)",
    date: "May 2024",
    icon: <FaAws color="#FF9900" size={36} />,
    track: "Cloud Infrastructure",
    verifyTag: "AWS Verified"
  },
  {
    title: "CyberOps Associate",
    issuer: "Cisco",
    date: "May 2024",
    icon: <SiCisco color="#1BA0D7" size={36} />,
    track: "Network Security",
    verifyTag: "Cisco Certified"
  },
  {
    title: "CCNA: Switching, Routing, and Wireless Essentials",
    issuer: "Cisco",
    date: "Nov 2023",
    icon: <SiCisco color="#1BA0D7" size={36} />,
    track: "Network Engineering",
    verifyTag: "Cisco Certified"
  },
  {
    title: "AWS Academy Graduate - AWS Academy Introduction to Cloud Semester 1",
    issuer: "Amazon Web Services (AWS)",
    date: "May 2023",
    icon: <FaAws color="#FF9900" size={36} />,
    track: "Cloud Computing",
    verifyTag: "AWS Verified"
  },
];

const SkillsPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredSkills = activeFilter === 'all'
    ? allSkills
    : allSkills.filter(s => s.track === activeFilter);

  return (
    <div style={{
      background: '#071325',
      minHeight: '100vh',
      padding: '60px 24px',
      color: '#ffffff',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <span className="badge badge-gold" style={{ marginBottom: '12px' }}>
            🎯 Verified Technical Matrix
          </span>
          <h1 style={{ fontSize: '2.5rem', color: '#ffffff', margin: '8px 0' }}>
            Skills &amp; Industry Certifications
          </h1>
          <p style={{ color: '#94a3b8', maxWidth: '650px', margin: '0 auto', fontSize: '1.05rem' }}>
            Filter Adedeji’s hands-on engineering capabilities and official credentials by domain.
          </p>
        </div>

        {/* Track Filter Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '10px',
          marginBottom: '40px'
        }}>
          {[
            { id: 'all', label: 'All Competencies', icon: <FaCertificate /> },
            { id: 'software', label: 'Software Dev', icon: <FaCode /> },
            { id: 'cloud', label: 'Cloud & DevOps', icon: <FaCloud /> },
            { id: 'data', label: 'Data Analytics', icon: <FaDatabase /> },
            { id: 'network', label: 'Networking', icon: <FaNetworkWired /> },
            { id: 'it', label: 'IT & IoT Systems', icon: <FaServer /> },
          ].map(btn => {
            const isActive = activeFilter === btn.id;
            return (
              <button
                key={btn.id}
                onClick={() => setActiveFilter(btn.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 20px',
                  borderRadius: '24px',
                  border: isActive ? '2px solid #45aaf2' : '1px solid rgba(255,255,255,0.15)',
                  background: isActive ? 'rgba(69, 170, 242, 0.25)' : 'rgba(16, 37, 66, 0.6)',
                  color: isActive ? '#ffffff' : '#94a3b8',
                  fontWeight: isActive ? '700' : '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                <span style={{ color: isActive ? '#45aaf2' : 'inherit' }}>{btn.icon}</span>
                <span>{btn.label}</span>
              </button>
            );
          })}
        </div>

        {/* Skills Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '20px',
          marginBottom: '60px'
        }}>
          {filteredSkills.map((skill, idx) => (
            <div key={idx} className="glass-card" style={{
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {skill.icon}
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', color: '#ffffff' }}>
                  {skill.name}
                </h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{skill.category}</span>
                  <span className="badge badge-green" style={{ padding: '2px 8px', fontSize: '0.75rem' }}>
                    {skill.proficiency}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CERTIFICATIONS SECTION */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <span className="badge badge-green" style={{ marginBottom: '12px' }}>
            📜 Industry Credentials
          </span>
          <h2 style={{ fontSize: '2.2rem', color: '#ffffff', margin: '8px 0' }}>
            7 Official Certifications &amp; Badges
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '1rem' }}>
            Formally accredited by AWS Academy, Cisco Networking Academy, and Red Hat Academy.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '24px',
          marginBottom: '60px'
        }}>
          {certifications.map((cert, idx) => (
            <div key={idx} className="glass-card" style={{
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              justify: 'space-between'
            }}>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div style={{ padding: '8px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                  {cert.icon}
                </div>
                <div>
                  <h3 style={{ margin: '0 0 6px 0', fontSize: '1.1rem', color: '#ffffff', lineHeight: 1.3 }}>
                    {cert.title}
                  </h3>
                  <div style={{ fontSize: '0.9rem', color: '#45aaf2', fontWeight: '600' }}>
                    {cert.issuer}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>
                    {cert.date}
                  </div>
                </div>
              </div>

              <div style={{
                display: 'flex',
                justify: 'space-between',
                alignItems: 'center',
                borderTop: '1px solid rgba(255,255,255,0.08)',
                paddingTop: '12px',
                marginTop: '8px'
              }}>
                <span className="badge badge-gold" style={{ fontSize: '0.78rem' }}>
                  {cert.track}
                </span>
                <span style={{ color: '#2ecc71', fontSize: '0.82rem', fontWeight: '600' }}>
                  ✓ {cert.verifyTag}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Skills Deck Link Callout */}
        <div className="glass-card" style={{
          padding: '32px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, rgba(11, 31, 58, 0.9) 0%, rgba(7, 19, 37, 0.95) 100%)',
          borderColor: 'rgba(248, 210, 16, 0.3)'
        }}>
          <h3 style={{ fontSize: '1.6rem', color: '#ffffff', marginBottom: '12px' }}>
            Looking for a Presentation Deck of my Skills &amp; Projects?
          </h3>
          <p style={{ color: '#94a3b8', fontSize: '1rem', maxWidth: '600px', margin: '0 auto 24px auto' }}>
            HR recruiters can view or download the standalone Skills Deck HTML presentation showcasing technical architecture diagrams, lab setups, and IoT projects.
          </p>
          <a
            href="/skills_deck.html"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ background: 'linear-gradient(135deg, #f8d210 0%, #e67e22 100%)', color: '#071325' }}
          >
            Open Skills Presentation Deck <FaExternalLinkAlt size={14} />
          </a>
        </div>

      </div>
    </div>
  );
};

export default SkillsPage;
